import { render, staticRenderFns } from "./not_find.vue?vue&type=template&id=bef5ffca&scoped=true&"
import script from "./not_find.vue?vue&type=script&lang=ts&"
export * from "./not_find.vue?vue&type=script&lang=ts&"
import style0 from "./not_find.vue?vue&type=style&index=0&id=bef5ffca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef5ffca",
  null
  
)

export default component.exports